module.exports = __webpack_public_path__ + "img/icon-initialoffer.ee2fdc7f.svg";